import React from "react"
import RelatedProviders from "../../components/RelatedProviders/RelatedProviders"
import RelatedProjects from "../../components/RelatedProjects/RelatedProjects.js"
import RelatedNews from "../../components/RelatedNews/RelatedNews.js"
import RelatedServices from "../../components/RelatedServices/RelatedServices"

const RelatedFields = ({
  relatedProviders = null,
  relatedServices = null,
  relatedNews = null,
  relatedProjects = null,
}) => {
  return (
    <>
      {relatedProviders && relatedProviders.length > 0 ? (
        <div className="container">
          <h2 className="secondaryTitle">Related Providers</h2>
          <RelatedProviders providers={relatedProviders} />
        </div>
      ) : null}
      {relatedServices && relatedServices.length > 0 ? (
        <div className="container">
          <h2 className="tertiaryTitle">Related Services</h2>
          <RelatedServices service={relatedServices}></RelatedServices>
        </div>
      ) : null}
      {relatedNews && relatedNews.length > 0 ? (
        <div className="container">
          <h2 className="tertiaryTitle">Related News</h2>
          <RelatedNews news={relatedNews}></RelatedNews>
        </div>
      ) : null}
      {relatedProjects && relatedProjects.length > 0 ? (
        <div className="container">
          <h2 className="tertiaryTitle">Related Projects</h2>
          <RelatedProjects projects={relatedProjects}></RelatedProjects>
        </div>
      ) : null}
    </>
  )
}

export default RelatedFields
